interface AboutType {
    firstName: string,
    lastName: string,
    about1: string,
    about2: string
  }
  
  
  export const AboutData: AboutType = {
    firstName: 'Mayur',
    lastName: 'Dev',
    about1: '<A Developer who loves to build cool things />',
    about2: '<Full-stack Developer And Web Designer />',
  };